<template>
  <b-container fluid class="content landing-page">
    <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
    <b-container fluid>
      <title-page
        :title="'Daftar Kartu Keluarga Terdapat Anomali'"
        :subtitle="'Daftar Kartu Keluarga yang terdapat anomali dan perlu dilakukan ground check. Klik pada tombol konfirmasi untuk mengunduh dokumen ground check dan tombol konfirmasi untuk menginput hasil konfirmasi.'"
      />
      <b-row>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation v-model="kodeProv" name="Provinsi">
            <option value="">Pilih Provinsi</option>
            <option
              v-for="item in provinsis"
              :value="item.kode_prov"
              v-bind:key="item.kode_prov"
            >
              {{ item.nama_prov }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation v-model="kodeKab" name="Kabupaten/Kota">
            <option value="">Pilih Kabupaten/Kota</option>
            <option
              v-for="item in kabupatenKotas"
              :value="item.kode_kab"
              v-bind:key="item.kode_kab"
            >
              {{ item.nama_kab }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation v-model="kodeKec" name="Kecamatan">
            <option value="">Pilih Kecamatan</option>
            <option
              v-for="item in kecamatans"
              :value="item.kode_kec"
              v-bind:key="item.kode_kec"
            >
              {{ item.nama_kec }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation v-model="kodeDesa" name="Desa/Kelurahan">
            <option value="">Pilih Desa/Kelurahan</option>
            <option
              v-for="item in desaKelurahans"
              :value="item.kode_desa"
              v-bind:key="item.kode_desa"
            >
              {{ item.nama_desa }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation
            v-model="kodeSls"
            name="Satuan Lingkungan Setempat"
          >
            <option value="">Pilih Satuan Lingkungan Setempat</option>
            <option
              v-for="item in satuanLingkunganSetempats"
              :value="item.kode_sls"
              v-bind:key="item.kode_sls"
            >
              {{ item.nama_sls }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="4" sm="12">
          <BSelectWithValidation v-model="anomali" name="Anomali">
            <option value="">Pilih Tipe Anomali</option>
            <option value="anomali1">Nik Tidak Valid</option>
            <option value="anomali2">KK Tidak Valid</option>
            <option value="anomali3">Perbedaan Alamat</option>
            <option value="anomali4">Perbedaan Jenis Kelamin</option>
            <option value="anomali5">
              Umur Kepala Keluarga Kurang Dari 11 Tahun
            </option>
            <option value="anomali6">
              Status Bukan Kepala Keluarga (1 ART)
            </option>
            <option value="anomali7">Sumber Data Perlu Konfirmasi</option>
          </BSelectWithValidation>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <b-row>
            <b-col cols="8">
              <BTextInputWithValidation
                v-model="search.nomor_kk"
                name="Nomor KK"
                placeholder="Isikan nomor kartu keluarga"
              />
            </b-col>
            <b-col>
              <b-button class="w-100" variant="primary" @click="cariNomorKk()"
                >Cari</b-button
              >
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6" md="6" sm="12">
          <b-row>
            <b-col cols="8">
              <BTextInputWithValidation
                v-model="search.nama"
                name="Nama Kepala Keluarga"
                placeholder="Isikan nama kepala keluarga"
              />
            </b-col>
            <b-col>
              <b-button class="w-100" variant="primary" @click="cariNama()"
                >Cari</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="table-responsive">
        <b-table
          class="table table-primary"
          :items="datas"
          :fields="fields"
          :per-page="perPage"
          bordered
          striped
          hover
        >
          <template v-slot:cell(no)="data">
            {{ (currentPage - 1) * 10 + (data.index + 1) }}.
          </template>
          <template v-slot:cell(aksi)="data">
            <div class="text-center" v-if="data.item.nomor_kk">
              <b-link
                class="btn btn-sm btn-primary"
                @click="
                  downloadKuesioner(data.item.kode_sls, data.item.nomor_kk)
                "
                >Kuesioner</b-link
              >
              <b-btn
                @click="konfirmasi(data.item.nomor_kk)"
                class="ml-1 btn btn-sm btn-warning"
                >Konfirmasi</b-btn
              >
            </div>
            <div class="text-center" v-else>
              <b-link
                class="btn btn-sm btn-primary"
                @click="
                  downloadKuesionerKkTidakValid(
                    data.item.kode_sls,
                    data.item.nama
                  )
                "
                >Kuesioner</b-link
              >
              <b-btn
                @click="
                  konfirmasiKkTidakValid(data.item.kode_sls, data.item.nama)
                "
                class="ml-1 btn btn-sm btn-warning"
                >Konfirmasi</b-btn
              >
            </div>
          </template>
        </b-table>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalPages"
        :per-page="perPage"
        align="right"
      ></b-pagination>
    </b-container>
  </b-container>
</template>
<script>
import titlePage from "@/components/Title";
import dataKonfirmasiService from "../../../services/sdpi/DataKonfirmasiService";
import masterWilayahService from "../../../services/sdpi/MasterWilayahService";
import BSelectWithValidation from "@/components/inputs/BSelectWithValidation";
import BTextInputWithValidation from "@/components/inputs/BTextInputWithValidation";
export default {
  components: { titlePage, BSelectWithValidation, BTextInputWithValidation },
  data: () => {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sdpi",
        },
        {
          text: "Konfirmasi",
          active: true,
        },
      ],
      perPage: 10,
      currentPage: 1,
      totalPages: 0,
      param: null,
      datas: [],
      fields: [
        "no",
        {
          label: "Nomor KK",
          key: "nomor_kk",
        },
        {
          label: "Nama Kepala Keluarga",
          key: "nama",
          thStyle: { minWidth: "200px" },
        },
        {
          label: "Provinsi",
          key: "nama_prov",
        },
        {
          label: "Kabupaten/Kota",
          key: "nama_kab",
        },
        {
          label: "Kecamatan",
          key: "nama_kec",
        },
        {
          label: "Desa/Kelurahan",
          key: "nama_desa",
        },
        {
          label: "SLS",
          key: "nama_sls",
        },
        {
          key: "aksi",
          label: "Aksi",
          thStyle: { minWidth: "225px" },
          tdClass: "text-center",
        },
      ],
      provinsis: [],
      kodeProv: "",
      kabupatenKotas: [],
      kodeKab: "",
      kecamatans: [],
      kodeKec: "",
      desaKelurahans: [],
      kodeDesa: "",
      satuanLingkunganSetempats: [],
      kodeSls: "",
      anomali: "",
      search: {
        nomor_kk: "",
        nama: "",
      },
    };
  },
  methods: {
    async getDatas(perPage, page, param) {
      await dataKonfirmasiService
        .getDataKonfirmasiNomorKk(perPage, page, param)
        .then(
          (result) => {
            this.datas = result.data.data.content;
            this.totalPages = result.data.data.totalElements;
          },

          (error) => {
            console.log(error);
          }
        );
    },
    async getProvinsi() {
      await masterWilayahService.getProvinsi().then(
        (result) => {
          this.provinsis = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKabupatenKota(id) {
      await masterWilayahService.getKabupatenKotaByProvinsi(id).then(
        (result) => {
          this.kabupatenKotas = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKecamatan(id) {
      await masterWilayahService.getKecamatanByKabupatenKota(id).then(
        (result) => {
          this.kecamatans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDesaKelurahan(id) {
      await masterWilayahService.getDesaKelurahanByKecamatan(id).then(
        (result) => {
          this.desaKelurahans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getSls(id) {
      await masterWilayahService.getSlsByDesa(id).then(
        (result) => {
          this.satuanLingkunganSetempats = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    downloadKuesioner(kode_sls, nomor_kk) {
      this.$router.push({
        name: "SDPIKuesionerKonfirmasi",
        params: { kode_sls: kode_sls, nomor_kk: nomor_kk },
      });
    },
    konfirmasi(id) {
      this.$router.push({ path: "/sdpi/entri-konfirmasi/" + id });
    },
    downloadKuesionerKkTidakValid(kode_sls, nama) {
      this.$router.push({
        name: "SDPIKuesionerKonfirmasiKkTidakValid",
        params: { kode_sls: kode_sls, nama: nama },
      });
    },
    konfirmasiKkTidakValid(kode_sls, nama) {
      this.$router.push({
        name: "SDPIEntriKonfirmasiKkTidakValid",
        params: { kode_sls: kode_sls, nama: nama },
      });
    },
    async getDataByNamas(page, q) {
      await dataKonfirmasiService.searchByNama(page, q).then(
        (result) => {
          this.datas = result.data.data.content;
          this.totalPages = result.data.data.totalElements;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDataByNomorKks(page, q) {
      await dataKonfirmasiService.searchByNomorKk(page, q).then(
        (result) => {
          this.datas = result.data.data.content;
          this.totalPages = result.data.data.totalElements;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    cariNama() {
      if (this.search.nama.trim() != "") {
        this.getDataByNamas(0, this.search.nama);
      } else {
        alert("Nama kepala keluarga harus terisi");
        this.getDatas(this.perPage, this.currentPage - 1, this.param);
      }
    },
    cariNomorKk() {
      if (this.search.nomor_kk.trim() != "") {
        this.getDataByNomorKks(0, this.search.nomor_kk);
      } else {
        alert("Nomor kartu keluarga harus terisi");
        this.getDatas(this.perPage, this.currentPage - 1, this.param);
      }
    },
  },
  mounted() {
    this.getProvinsi();
    this.getDatas(this.perPage, this.currentPage - 1, this.param);
  },
  watch: {
    currentPage(val) {
      this.currentPage = val;
      if (this.search.nomor_kk.trim() == "" && this.search.nama.trim() == "") {
        this.getDatas(this.perPage, val - 1, this.param);
      } else {
        if (this.search.nomor_kk.trim() != "") {
          this.getDataByNomorKks(val-1, this.search.nomor_kk);
        } else {
          this.getDataByNamas(val-1, this.search.nama);
        }
      }
    },
    kodeProv(val) {
      if (val) {
        this.kodeKab = "";
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        if (this.anomali) {
          this.param = "kode_prov=" + val + "&rule=" + this.anomali;
        } else {
          this.param = "kode_prov=" + val;
        }
        this.getDatas(this.perPage, 0, this.param);
        this.getKabupatenKota(val);
      }
    },
    kodeKab(val) {
      if (val) {
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        if (this.anomali) {
          this.param = "kode_kab=" + val + "&rule=" + this.anomali;
        } else {
          this.param = "kode_kab=" + val;
        }
        this.getDatas(this.perPage, 0, this.param);
        this.getKecamatan(val);
      }
    },
    kodeKec(val) {
      if (val) {
        this.kodeDesa = "";
        this.kodeSls = "";
        if (this.anomali) {
          this.param = "kode_kec=" + val + "&rule=" + this.anomali;
        } else {
          this.param = "kode_kec=" + val;
        }
        this.getDatas(this.perPage, 0, this.param);
        this.getDesaKelurahan(val);
      }
    },
    kodeDesa(val) {
      if (val) {
        this.kodeSls = "";
        if (this.anomali) {
          this.param = "kode_desa=" + val + "&rule=" + this.anomali;
        } else {
          this.param = "kode_desa=" + val;
        }
        this.getDatas(this.perPage, 0, this.param);
        this.getSls(val);
      }
    },
    kodeSls(val) {
      if (val) {
        if (this.anomali) {
          this.param = "kode_sls=" + val + "&rule=" + this.anomali;
        } else {
          this.param = "kode_sls=" + val;
        }

        this.getDatas(this.perPage, 0, this.param);
      }
    },
    anomali(val) {
      if (val) {
        if (this.kodeSls) {
          this.param = "kode_sls=" + this.kodeSls + "&rule=" + val;
        } else if (this.kodeDesa) {
          this.param = "kode_desa=" + this.kodeDesa + "&rule=" + val;
        } else if (this.kodeKec) {
          this.param = "kode_kec=" + this.kodeKec + "&rule=" + val;
        } else if (this.kodeKab) {
          this.param = "kode_kab=" + this.kodeKab + "&rule=" + val;
        } else if (this.kodeProv) {
          this.param = "kode_prov=" + this.kodeProv + "&rule=" + val;
        } else {
          this.param = "rule=" + val;
        }
        this.getDatas(this.perPage, 0, this.param);
      }
    },
  },
};
</script>
